import React from 'react';
import _ from 'lodash';
import clsx from 'clsx';

type SwitcherProps = {
  onChange: () => void;
  checked: boolean;
  size: 'lg' | 'sm' | 'md';
  label?: string;
  disabled?: boolean;
  className?: string;
};

const Switcher = (props: SwitcherProps) => {
  const { checked, label, size } = props;

  const labelId = _.uniqueId();

  const handleKeyDown = (ev: any) => {
    if (ev.keyCode == 13) {
      props.onChange();
    }
  };

  return (
    <div className={clsx('custom-control custom-switch', 'custom-switch-' + size, props.className)}>
      <input
        disabled={props.disabled}
        onKeyDown={handleKeyDown}
        onChange={props.onChange}
        type="checkbox"
        id={labelId}
        className="custom-control-input"
        checked={checked}
      />
      <label className="custom-control-label hand-cursor" htmlFor={labelId}>
        {label ? label : ''}
      </label>
    </div>
  );
};

export default Switcher;
